import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { showNotification } from "@mantine/notifications";
import { customAxios } from "lib/axios";
import { CalendarDepartmentScope } from "./getholidayCalendar";

export interface TimeConfig {
  date?: string;
  startTime: string;
  endTime: string;
  totalHours: number;
}

// Note: the server returns a bare array (TimeConfig[]) for this endpoint, not
// an envelope object — kept as-is to avoid touching any other consumer of it.
export type TimeConfigResponse = TimeConfig[];

const fetchTimeConfigs = async (
  month: number,
  year: number,
  scope?: CalendarDepartmentScope
): Promise<TimeConfigResponse> =>
  (
    await customAxios.get<TimeConfigResponse>(
      `/attendance/getCalenderTimeconfig`,
      { params: { month, year, ...(scope ? { scope } : {}) } }
    )
  ).data;

export const useGetCalendarTimeConfig = (
  month: number,
  year: number,
  scope?: CalendarDepartmentScope
) =>
  useQuery<TimeConfigResponse, AxiosError>(
    ["workingHours", month, year, scope ?? "auto"],
    () => fetchTimeConfigs(month, year, scope),
    {
      onError: (error) =>
        showNotification({
          title: "Error Loading Time Configurations",
          message:
            (error.response?.data as { message?: string })?.message ??
            "Failed to load time configurations",
          color: "red",
        }),
      staleTime: 0,
      retry: 1,
      refetchOnMount: "always",
    }
  );
